import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function Base64ToolPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Base64 Encoder & Decoder - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free Base64 encoder and decoder tool. Encode text to Base64 or decode Base64 strings instantly.",
    "featureList": [
      "Base64 encoding",
      "Base64 decoding",
      "Instant conversion",
      "Offline support",
      "No data collection",
      "Copy to clipboard"
    ]
  };

  return (
    <>
      <SEO
        title="Base64 Encoder & Decoder - Encode and Decode Base64 Online | JsonToonCraft"
        description="Free Base64 encoder and decoder tool. Encode text to Base64 or decode Base64 strings instantly. Works offline, no data collection. Fast and secure."
        keywords="Base64 encoder, Base64 decoder, encode Base64, decode Base64, Base64 online, Base64 tool"
        canonicalUrl="https://jsontooncraft.com/dev-tools/base64"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="base64" />
    </>
  );
}
